import api from './api';

export interface Curso {
    id: number;
    nome: string;
    codigo_sigaa: string;
    nivel?: string;
    pivot?: {
        user_id: number;
        curso_codigo_sigaa: string;
        created_at: string;
        updated_at: string;
        status: string;
    };
}

export interface Aluno {
    id: number;
    user_id?: number;
    nome: string;
    cpf: string;
    matricula: string;
    status: string;
    created_at: string;
    updated_at: string;
    user?: {
        id: number;
        name: string;
        email: string;
        auth_mode?: 'local' | 'ldap';
    };
    cursos?: Curso[];
    email_queued?: boolean;
}

export interface AlunoFormData {
    nome: string;
    cpf: string;
    matricula: string;
    email: string;
    status?: string;
    curso_codigos: string[];
}

export interface SyncAlunosParams {
    ano: number;
    periodo: number;
    curso_id?: string;
}

export type AlunoStatus = 'ATIVO' | 'INATIVO' | 'DESLIGADO' | 'CANCELADO' | 'EXCLUÍDO';
export type AuthMode = 'local' | 'ldap';

export interface AlunoListParams {
    search?: string;
    page?: number;
    per_page?: number;
    status?: AlunoStatus;
    auth_mode?: AuthMode;
}

export default {
    async getAlunos(params?: AlunoListParams) {
        return api.get('/admin/alunos', { params });
    },

    async getAluno(id: number) {
        return api.get(`/admin/alunos/${id}`);
    },

    async createAluno(data: AlunoFormData) {
        return api.post('/admin/alunos', data);
    },

    async updateAluno(id: number, data: AlunoFormData) {
        return api.put(`/admin/alunos/${id}`, data);
    },

    async deleteAluno(id: number) {
        return api.delete(`/admin/alunos/${id}`);
    },

    async syncSigaa(params: SyncAlunosParams) {
        return api.post('/admin/alunos/sync-sigaa', params);
    },

    async getMeusCursos() {
        return api.get('/aluno/meus-cursos');
    }
};
